import React from 'react';
import { useEnableNewOrderImport } from '../../feature-flags/hooks/use-enable-new-order-import';
import OrderImportModal from './order-import-modal';
import { OrderImportDrawer } from './order-import-drawer';

export const OrderImport = () => {
  const isNewOrderImportEnabled = useEnableNewOrderImport();
  return isNewOrderImportEnabled ? <OrderImportDrawer /> : <OrderImportModal />;
};
